import { useEffect, useState } from "react";

interface UseSlideMainDrawerProps {
  menuOpen: boolean;
  menuDrawerRef: React.RefObject<HTMLDivElement>;
}

export const useSlideMainDrawer = ({
  menuDrawerRef,
  menuOpen,
}: UseSlideMainDrawerProps) => {
  /** To be able to slide from behind the menu except for Mobile view */
  const [showSubMenuBehindMainMenu, setShowSubMenuBehindMainMenu] =
    useState(false);

  useEffect(() => {
    if (menuOpen && menuDrawerRef.current) {
      /** Defer execution of translateX(0) to load the drawer first before sliding */
      setTimeout(
        (menuDrawerDiv) => {
          menuDrawerDiv.style.transform = "translateX(0)";
        },
        0,
        menuDrawerRef.current
      );
    }
  }, [menuOpen, menuDrawerRef]);

  useEffect(() => {
    if (!menuOpen) {
      setShowSubMenuBehindMainMenu(false);
    }
  }, [menuOpen]);

  return {
    showSubMenuBehindMainMenu,
    setShowSubMenuBehindMainMenu,
  };
};
